import styled from 'styled-components';
import { Typography } from '~/ui/components';
import { themeToggleColor } from '~/common/utils/theme';

export const ListReplyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ListReplyText = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'label',
  weight: 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))``;
